import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const BusinessManagerRouter = lazy(() => import('../pages/index'));
const TicketList = lazy(() => import('../pages/Tickets/TicketList'));
const TicketDetail = lazy(() => import('../pages/Tickets/TicketDetail'));
const Boleto = lazy(() => import('../pages/Boleto'));
const Contrato = lazy(() => import('../pages/Contrato'));

export interface IRoute {
  path: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.BUSINESS_MANAGER,
    component: BusinessManagerRouter,
    accessDeniedDescription: 'ver BM',
    routes: [
      {
        path: Location.BUSINESS_MANAGER_DETAIL,
        component: TicketDetail,
        accessDeniedDescription: 'ver detalhe',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_TICKETS,
        component: TicketList,
        accessDeniedDescription: 'Tickets',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_BOLETOS,
        component: Boleto,
        accessDeniedDescription: 'Financeiro',
        exact: true,
      },
      {
        path: Location.BUSINESS_MANAGER_CONTRATO,
        component: Contrato,
        accessDeniedDescription: 'Financeiro',
        exact: true,
      },
    ],
  },
];

export default routes;
